/* eslint-disable */
// Progressively enhance `<ol>`s (with nested `<img>`s) into trigger buttons for a ModalDialog with a Carousel inside it. The Carousel itself is a copy of the original `<ul>` or `<ol>`, enhanced into a Carousel.

class Lightbox {
    constructor() {
        this.instances = document.querySelectorAll('[data-progressive-enhancement="off"][data-progressive-enhancement-type="lightbox"]');
        this.lightboxesStatus = null;
    }

    init(carousel, helpers, modalDialog) {
       const self = this;

       self.carousel = carousel;
       
       self.helpers = helpers;

       self.modalDialog = modalDialog;

       self.enhanceAll(self);
    }

    enhance(instance, self) {
        let carousel = document.createElement('div'),
            carouselList = document.createElement('ol'),
            thumbnails = instance.querySelectorAll('ol > li > img'),
            lightbox = document.createElement('div'),
            lightboxHeading = document.createElement('h2'),
            lightboxHeadingI = document.createElement('i'),
            lightboxHeadingSpan = document.createElement('span');

        lightbox.appendChild(lightboxHeading);

        lightboxHeading.appendChild(lightboxHeadingI);

        lightboxHeadingI.appendChild(document.createTextNode(instance.parentElement.querySelector('#' + instance.getAttribute('aria-labelledby')).textContent));

        lightboxHeading.appendChild(lightboxHeadingSpan);

        lightboxHeadingSpan.appendChild(document.createTextNode(' ' + i18n.Lightbox.lightbox));

        lightbox.appendChild(carousel);

        carousel.appendChild(carouselList);

        thumbnails.forEach((thumbnail, i = 1) => {
            let image = thumbnail.cloneNode(),
                imageWrapper = document.createElement('div'),
                slide = document.createElement('li');

            imageWrapper.className = 'img-wrapper';

            carouselList.appendChild(slide);
            slide.appendChild(imageWrapper);
            imageWrapper.appendChild(image);

            image.setAttribute('src', image.getAttribute('data-lightbox-src'));

            image.setAttribute('srcset', image.getAttribute('data-lightbox-srcset'));

            image.setAttribute('sizes', image.getAttribute('data-lightbox-sizes'));
            
            image.setAttribute('width', image.getAttribute('data-lightbox-width'));

            image.setAttribute('height', image.getAttribute('data-lightbox-height'));

            image.removeAttribute('style');

            thumbnail.dataset.slickGoTo = i;
        });

        lightbox.id = instance.id + '__lightbox';

        lightboxHeading.id = lightbox.id + '__heading';

        lightbox.setAttribute('aria-labelledby', lightboxHeading.id);

        lightbox.hidden = true;
        lightbox.dataset.progressiveEnhancement = 'off'
        lightbox.dataset.progressiveEnhancementType = 'modal-dialog';

        instance.appendChild(lightbox);

        carousel.dataset.progressiveEnhancement = 'off';
        carousel.dataset.progressiveEnhancementType = 'carousel';
        
        self.modalDialog.enhance(lightbox, self.modalDialog);
        self.carousel.enhance(carousel, self.carousel);

        
        (async() => {
            let $slickSlider,
                modalDialog,
                protoButton;
            
            while('off' === instance.dataset.progressiveEnhancement) {
                await new Promise(resolve => setTimeout(resolve, 50));
            }   

            $slickSlider = $(carousel).find('.slick-slider');

            protoButton = instance.querySelector('button.js-modal-dialog-trigger-button');

            protoButton.hidden = true;
            
            protoButton = instance.removeChild(protoButton);
            
            while(protoButton.childNodes[0]){
                protoButton.removeChild(protoButton.childNodes[0]);
            }

            modalDialog = document.querySelector('#' + protoButton.getAttribute('aria-controls'));

            modalDialog.classList.add('modal-dialog--lightbox');

            thumbnails.forEach((thumbnail, i) => {
                let button = protoButton.cloneNode(),
                    listItem = thumbnail.parentElement,
                    buttonDescription = document.createElement('p');

                button.id = button.id + '--' + i;

                button.dataset.slickGoTo = thumbnail.dataset.slickGoTo;

                button.appendChild(listItem.removeChild(thumbnail));

                listItem.appendChild(button);

                listItem.appendChild(buttonDescription);

                buttonDescription.id = button.id + '__description';

                buttonDescription.classList.add('visually-hidden');

                button.setAttribute('aria-describedby', buttonDescription.id);

                buttonDescription.setAttribute('aria-hidden', 'true');

                buttonDescription.appendChild(document.createTextNode(wp.i18n.sprintf(i18n.Lightbox.clickToOpenOnThisSlide, lightboxHeading.textContent)));

                button.hidden = false;

                button.addEventListener('click', (e) => {
                    let closeButton;

                    $slickSlider.slick('slickSetOption', 'arrowsPlacement', 'split');

                    $slickSlider.slick('slickGoTo', parseInt(e.currentTarget.dataset.slickGoTo));

                    self.modalDialog.openModalDialog(e, self.modalDialog);

                    closeButton = modalDialog.querySelector('.js-modal-dialog__close-button');

                    closeButton.dataset.modalDialogTriggerId = button.id;

                    modalDialog.querySelector('#' + modalDialog.getAttribute('aria-labelledby')).classList.add('visually-hidden');
                });
            });
        })();

        instance.dataset.progressiveEnhancement = 'on';

        return instance;
    }

    enhanceAll(self) {
        if (self.lightboxesStatus !== 'on') {
            for (let i = 0; i < self.instances.length; i++) {
                let currentInstance = self.instances[i];

                currentInstance = self.enhance(self.instances[i], self);
            }

            self.lightboxesStatus = true;
        }

        if(self.lightboxesStatus) {
            if(document.documentElement.dataset.progressiveEnhancements) {
                document.documentElement.dataset.progressiveEnhancements += ' lightbox';
            } else {
                document.documentElement.dataset.progressiveEnhancements = 'lightbox';
            } 
        }

    }
}// end Class

// Singleton
export default Lightbox;